import image1 from "../../static/images/bg1.jpg";
import image2 from "../../static/images/bg2.jpg";
import image3 from "../../static/images/bg3.jpg";
import image4 from "../../static/images/mobilebg1.jpg";
import image5 from "../../static/images/mobilebg2.jpg";
import image6 from "../../static/images/mobilebg3.jpg";
export const CarousalItems = [
  {
    background: `url(${image1})`,
    mobilebg: `url(${image4})`,
    header: "WE PROVIDE SATISFACTION",
    name: "Best It Solutions Company In The Global Community ",
    description:
      "We are a highly client-centric company that uses industry-leading best practices, cutting-edge tools & technologies to ensure that you receive the highest quality services for…",
  },
  {
    background: `url(${image2})`,
    mobilebg: `url(${image5})`,
    header: "WE HIRE THE",
    name: "To Our Upcoming Buisness Partners And Clients",
    description:
      "We are a highly client-centric company that uses industry-leading best practices, cutting-edge tools & technologies to ensure that you receive the highest quality services for…",
  },
  {
    background: `url(${image3})`,
    mobilebg: `url(${image6})`,
    header: "WE ARE THE",
    name: "Best It Solutions And Buisness Services In Tech Market",
    description:
      "We are a highly client-centric company that uses industry-leading best practices, cutting-edge tools & technologies to ensure that you receive the highest quality services for…",
  },
];
